<template>
  <div class="warningInfo">
    <div class="searchWrap">
      
      <div  class="searchNews">
        <div class="itemWrap">
          <label>日期</label>
          <el-date-picker type="daterange" :editable="true" value-format="yyyy-MM-dd" range-separator="至"
            start-placeholder="開始日期" 
            end-placeholder="結束日期"
            v-model="rangeDate"
          ></el-date-picker>
        </div>
        <div class="itemWrap">
          <label>網站</label>
          <el-select v-model="selSites" placeholder="請選擇新聞網站" no-data-text="目前無名單" multiple clearable>
            <!-- <el-option key="999" label="全部" value="" ></el-option>  -->
            <el-option v-for="(item,index) in webSiteOptions" :key="index"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </div>
        <div class="itemWrap">
          <label>關鍵字</label>
          <el-input v-model.trim="keyword" placeholder="請輸入新聞關鍵字" clearable></el-input>
        </div>
        <div class="itemWrap" style="margin-left:15px;">
          <el-button type="primary" @click="handleSearch"><font-awesome-icon icon="search"  style="margin-right:5px;" />查詢</el-button>
        </div>
      </div>   

      <div class="content">
        <!-- *新聞資料* -->
        <el-table style="width: 100%" ref="multipleTable" :data="tableData"  :header-cell-style="{ background: '#FFF6EF', border: '1px #ddd solid', textAlign: 'center'}"  empty-text="暫無數據" @select="handleSelectionChange" >
          <!-- <el-table-column type="selection" width="50" ></el-table-column> -->
          <el-table-column prop="NewsTitle" label="新聞標題" >
            <template slot-scope="scope">
              <el-tooltip content="將開啟新頁" placement="top">
                <a class="goDetailPage" @click="goDetailPage(scope.row)">{{scope.row.NewsTitle }}</a>
              </el-tooltip>
            </template></el-table-column>
          <el-table-column prop="NewsTime" label="新聞時間" min-width="15%">
            <template slot-scope="scope">
              <div>{{ scope.row.NewsTime | moment("YYYY-MM-DD") }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="NewsSite" label="新聞網站" min-width="20%"></el-table-column>
          <el-table-column prop="NewsChannel" label="新聞頻道" min-width="10%"> </el-table-column>
        </el-table>
        
      </div>
      <Pagination @currentChange="pageChange" :pageSize="this.listQuery.Page_Size" :propsCurrentPage="this.listQuery.Page_Num" :totalLists="totalLists" :maxPageLimit="50"></Pagination>
    </div> 


  </div>
</template>

<script>
import Pagination from '../components/Pagination.vue';
import moment from "moment";

export default {
  components: {Pagination},
  data() {
    return {
      placeholder:"",
      
      totalLists: 0,
      openAddProjSort : false,
      searChsanInputListID:"",
      searChsanSearchType:"",
      webSiteOptions: [],
      newsSelectValue:"searchNews",
      rangeDate:[moment().add(-7, "days").format("YYYY-MM-DD"),moment().format("YYYY-MM-DD")],
      listQuery: {
        // Start_Date : this.rangeDate[0],
        // End_Date : this.rangeDate[1],
        Page_Num : 1,
        Page_Size : 10,        
        SearchContent: []
      },
      projSort : "",
      projTheme : "",
      sortList : [],
      themeList: [],     
      selSites: [],    
      keyword: "",
      tableData: [],
      // userRole: this.$store.state.userInfo.Role,
      multipleSelection:[],
      manageAllSelection:{
        searchNews:[],
        searChsan:[],
        searchConstr:[],
        searchLabor:[],
        searchEnviroment:[]
      },
      selectData: [],
      selectPage: [],
    };
  },
  computed: {
    composeName(row){
      console.log(row);
    },
    filterDate() {
      return (date) => {
        return this.$dayjs(date).format('YYYY-MM-DD HH:mm:ss');
      };
    },


  },
  methods: {  
    async handleSearch(){
      this.listQuery.Page_Num = 1  
      if( this.keyword && this.keyword.trim() !== '' )
          this.$queryRecord(this, this.keyword, 'keyword');  // 記錄搜尋關鍵字          
      await this.getList()
    },
    async getWebSiteOptions() {
      return new Promise((resolve)=>{
        let temp = {
          Type: ['NewsSite'],
        };
        this.$api.apimgrs.getOptions(temp).then((res) => {
          this.webSiteOptions = res.NewsSite;
          resolve()
        });
      })
    },

    async getList(isSys) {      
      
      if ( !isSys ) 
        this.listQuery.isSys = false;
      else 
        this.listQuery.isSys = true;

      this.$store.dispatch('loadingHandler', true);

      

      if( !! this.rangeDate) {
        this.listQuery.Start_Date = this.rangeDate[0];
        this.listQuery.End_Date = this.rangeDate[1];
      }
      else {
        delete this.listQuery.Start_Date;
        delete this.listQuery.End_Date;
      }
      
      

      if( this.selSites.length == 0) {
        delete this.listQuery.NewsSite
      }
      else {
        this.listQuery.NewsSite = this.selSites;
      }

      if( this.keyword.length==0)
        delete this.listQuery.SearchContent;
      else {      
        let sc = [];
        sc.push(this.keyword);
        this.listQuery.SearchContent = sc;
      }

      
      console.log(this.listQuery);
      
      await this.$api.apimgrs.searchNews(this.listQuery).then((res)=>{
        this.tableData = res.data;
        this.totalLists = res.total;
        // console.log(res.data);
        // this.$store.dispatch('loadingHandler', false);
        // this.makeTableShowChecked()

      }, err => {
        this.$notify.error({
        title: "錯誤",
        message: "網路發生錯誤",
        type: "Error"});
      });
      this.$store.dispatch('loadingHandler', false);

    },

    goDetailPage(data) {
        console.log(data);
        let routeUrl = this.$router.resolve({
            path: "/detailNews",
            query: { id: data.DataID },                
        });
        window.open(routeUrl.href, "_blank");
    },    

    handleSelectionChange(val) {
       console.log("checked",val);
      // console.log(this.listQuery.Page_Num);
      if (val.length !== 0) {
        this.selectData[this.listQuery.Page_Num - 1] = val.map(x=>x.DataID);
        this.selectPage.push(this.listQuery.Page_Num - 1);
      }
      else {
        var idx = this.selectPage.indexOf(this.listQuery-1);
        if( idx >=0 ) {
          this.selectPage.slice(idx,1);
        }
      }
    },    

    async pageChange(val) {
      this.listQuery.Page_Num = val;      
      await this.getList();
    }, 
  },
  async mounted() {
    await this.getWebSiteOptions();
    // console.log(this.webSiteOptions);

    // 如果在querystring有q參數, 則帶入關鍵字搜尋
    const q = this.$route.query.q;
    if( q && q.trim() !== '' ) {
      this.keyword = q;
      this.$queryRecord(this, this.keyword, 'keyword');  // 記錄搜尋關鍵字          
      await this.getList();
    }else {
      // 代表是第一次進入此頁面, 直接帶入上次的搜尋條件, 直接給予系統搜尋
      await this.getList(true);
    }
    
    //await this.getReelType();
  },
};
</script>

<style lang="scss" scoped>
// * {
//   outline: red solid 1px;
// }

.goDetailPage {
  font-size: 1.1rem;
}

.warningInfo {
  background: linear-gradient(-135deg, #FFF 20%, #fff 50%, transparent 50%)
    center center / 100% 100%;
  min-height: 100vh;
  padding: 0px 0px;



  .searchWrap {
    display: flex;
    flex-direction: column;
    align-items: center;

    .searchNews{
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      width: 90%;
      

      .itemWrap{
        display: flex;
        align-items: center;
        margin-bottom: 10px;
        label{
          white-space: nowrap;
          display: block;
          text-align: right;
          margin-right: 10px;
        }
      }
    }

    .content {
      display: flex;
      justify-content: center;
      margin: 15px 5%;  
      width: 90%;    


    }

  }

      #page {
        width: 90%;
      }
  .WarningListPopUp {
    width: 100%;
    height: 100vh;
    background-color: rgba(133, 133, 133, 0.7);
    position: fixed;
    z-index: 9999999;
    left: 0;
    top: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    .popup {
      position: relative;
      text-align: center;
      width: 20%;
      padding: 5%;
      background-color: white;
      border-radius: 10px;
      .el-icon-close{
        cursor: pointer;
        position: absolute;
        top: 10px;
        right: 10px;
      }
    }
  }
  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
  a{
    text-decoration: underline;
    color: blue;
    cursor: pointer;
    
  }
}
</style>
